// extracted by mini-css-extract-plugin
export default {"emptyBag":"EmptyCart_emptyBag__7NtOz","inGrid":"EmptyCart_inGrid__JXYfX","bagImage":"EmptyCart_bagImage__e41MO"};